import api from './api';

export interface Provincia {
    codigoProvincia: number;
    nombreProvincia?: string;
    cmdgr?: number;
}

export interface ProvinciaSearchParams {
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface ProvinciaPagedResult {
    items: Provincia[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const provinciaService = {
    getProvincias: async (params?: ProvinciaSearchParams): Promise<ProvinciaPagedResult> => {
        const response = await api.get('/api/provincias', params ? { params } : {});
        const data = response.data;
        
        if (Array.isArray(data)) {
            return {
                items: data,
                totalCount: data.length,
                pageNumber: 1,
                pageSize: data.length,
                totalPages: 1
            };
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data as ProvinciaPagedResult;
        }
        
        return {
            items: [],
            totalCount: 0,
            pageNumber: 1,
            pageSize: params?.pageSize || 10,
            totalPages: 0
        };
    },

    getProvincia: async (codigoProvincia: number): Promise<Provincia> => {
        const response = await api.get<Provincia>(`/api/provincias/${codigoProvincia}`);
        return response.data;
    },

    createProvincia: async (provincia: Provincia): Promise<Provincia> => {
        const response = await api.post<Provincia>('/api/provincias', provincia);
        return response.data;
    },

    updateProvincia: async (codigoProvincia: number, provincia: Provincia): Promise<void> => {
        await api.put(`/api/provincias/${codigoProvincia}`, provincia);
    },

    deleteProvincia: async (codigoProvincia: number): Promise<void> => {
        await api.delete(`/api/provincias/${codigoProvincia}`);
    }
};

export default provinciaService; 